import React from "react";
import GreenCheck from "../../assets/GreenCheck.png";

import styles from "./PaymentSuccess.module.scss";

export default function PaymentSuccess() {
  return (
    <div className={styles.contentContainer}>
      <img className={styles.greenCheck} src={GreenCheck} alt="Success" />
      <h1 className={styles.title}>Payment Successful</h1>
      <p className={styles.description}>
        Your ticket and reciept have been emailed.
      </p>
    </div>
  );
}
